export const BUYING_GROUP_CHOICES = [
    { id: 'psi', label: 'PSI', value: 'PSI' },
    { id: 'vertical-vet', label: 'Vertical Vet', value: 'Vertical Vet' },
    { id: 'vmg', label: 'VMG', value: 'VMG' },
    { id: 'tvc', label: 'TVC', value: 'TVC' },
    { id: 'other', label: 'Other', value: 'Other' },
];
export const US_STATES = [
    'AL',
    'AK',
    'AZ',
    'AR',
    'CA',
    'CO',
    'CT',
    'DE',
    'FL',
    'GA',
    'HI',
    'ID',
    'IL',
    'IN',
    'IA',
    'KS',
    'KY',
    'LA',
    'ME',
    'MD',
    'MA',
    'MI',
    'MN',
    'MS',
    'MO',
    'MT',
    'NE',
    'NV',
    'NH',
    'NJ',
    'NM',
    'NY',
    'NC',
    'ND',
    'OH',
    'OK',
    'OR',
    'PA',
    'RI',
    'SC',
    'SD',
    'TN',
    'TX',
    'UT',
    'VT',
    'VA',
    'WA',
    'WV',
    'WI',
    'WY',
];
